"use strict";

import template from "./entidades.html";
import controller from "./entidades.controller";

const EntidadesComponent = {
  controller,
  template,
};

export default EntidadesComponent;



// WEBPACK FOOTER //
// ./src/app/components/entidades/entidades.component.js